// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_eW","advertDetailContactGroup__header":"c-n_eX","advertDetailContactGroup__value":"c-n_eY"};